import * as React from "react";

function SvgEye(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18 18" {...props}>
      <defs>
        <clipPath id="eye_svg__prefix__clip-path">
          <path
            id="eye_svg__prefix__Ret\xE2ngulo_361"
            fill="currentColor"
            stroke="currentColor"
            d="M0 0h18v18H0z"
            data-name="Ret\xE2ngulo 361"
            transform="translate(737 241)"
          />
        </clipPath>
        <style>
          {
            ".eye_svg__prefix__cls-3{fill:currentColor;stroke:currentColor;stroke-width:.5px}"
          }
        </style>
      </defs>
      <g
        id="eye_svg__prefix__Grupo_de_m\xE1scara_59"
        clipPath="url(#eye_svg__prefix__clip-path)"
        data-name="Grupo de m\xE1scara 59"
        opacity={0.9}
        transform="translate(-737 -241)"
      >
        <g
          id="eye_svg__prefix__view_2_"
          data-name="view (2)"
          transform="translate(737.563 245.5)"
        >
          <g id="eye_svg__prefix__Grupo_480" data-name="Grupo 480">
            <g id="eye_svg__prefix__Grupo_479" data-name="Grupo 479">
              <path
                id="eye_svg__prefix__Caminho_145"
                d="M16.768 7.655C16.617 7.46 13.025 2.9 8.437 2.9S.258 7.46.107 7.654a.5.5 0 000 .618c.151.194 3.743 4.754 8.33 4.754s8.18-4.559 8.33-4.753a.5.5 0 00.001-.618zm-8.33 4.324c-3.379 0-6.306-3.026-7.172-4.015.865-.99 3.786-4.015 7.172-4.015s6.306 3.026 7.172 4.015c-.865.99-3.786 4.015-7.173 4.015z"
                className="eye_svg__prefix__cls-3"
                data-name="Caminho 145"
                transform="translate(0 -2.901)"
              />
            </g>
          </g>
          <g
            id="eye_svg__prefix__Grupo_482"
            data-name="Grupo 482"
            transform="translate(4.877 1.502)"
          >
            <g id="eye_svg__prefix__Grupo_481" data-name="Grupo 481">
              <path
                id="eye_svg__prefix__Caminho_146"
                d="M8.4 4.835a3.56 3.56 0 103.56 3.56 3.565 3.565 0 00-3.56-3.56zm0 5.934A2.374 2.374 0 1110.769 8.4 2.376 2.376 0 018.4 10.769z"
                className="eye_svg__prefix__cls-3"
                data-name="Caminho 146"
                transform="translate(-4.835 -4.835)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgEye;

